// 主路由
export const chartMain = [
  {
    name: 'chart',
    path: '/chart',
    meta: {
      title: '数据图表',
      icon: 'shezhi',
      plugin: 'chart'
    }
  },
  {
    path: '/chart/list',
    name: 'chartList',
    component: () => import('@/views/plugins/chart/List.vue'),
    meta: {
      title: '图表列表',
      plugin: 'chart',
      keepAlive: true
    }
  },
  {
    path: '/chart/edit/:id?',
    name: 'chartEdit',
    component: () => import('@/views/plugins/chart/Edit.vue'),
    meta: {
      title: '编辑图表',
      plugin: 'chart'
    }
  },
  {
    path: '/chart/project',
    name: 'chartProjectList',
    component: () => import('@/views/plugins/chart/project/List.vue'),
    meta: {
      title: '项目列表',
      plugin: 'chart',
      keepAlive: true
    }
  },
  {
    path: '/chart/project/edit/:id?',
    name: 'chartProjectEdit',
    component: () => import('@/views/plugins/chart/project/Edit.vue'),
    meta: {
      title: '编辑项目',
      plugin: 'chart'
    }
  },
  {
    path: '/chart/project/design/:id',
    name: 'chartProjectDesign',
    component: () => import('@/views/plugins/chart/project/Design.vue'),
    meta: {
      title: '项目设计',
      plugin: 'chart'
    }
  },
  {
    path: '/chart/display',
    name: 'chartDisplay',
    component: () => import('/@/views/plugins/chart/Display.vue'),
    meta: {
      title: '图表展示',
      icon: 'el-icon-data-line'
    }
  }
]
export default chartMain

